import { NgFor, NgStyle } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

interface ParticleConfig {
  size: string;
  color: string;
  opacity: number;
  delay: string;
  startX: string;
  startY: string;
  startZ: string;
  endX: string;
  endY: string;
  endZ: string;
}

@Component({
  selector: 'app-dust-particles',
  standalone: true,
  imports: [NgFor, NgStyle],
  templateUrl: './dust-particles.component.html',
  styleUrls: ['./dust-particles.component.css'],
})
export class DustParticlesComponent implements OnInit {
  @Input() count = 30;
  particles: ParticleConfig[] = [];

  ngOnInit() {
    this.particles = this.generateParticles(this.count);
  }

  generateParticles(count: number): ParticleConfig[] {
    const particles: ParticleConfig[] = [];
    const gridSize = Math.ceil(Math.sqrt(count));
    for (let i = 0; i < count; i++) {
      const xCell = i % gridSize;
      const yCell = Math.floor(i / gridSize);
      // Jitter each cell a bit for natural look
      const jitter = () => (Math.random() - 0.5) * (100 / gridSize) * 0.7;
      const startX = Math.min(99, Math.max(0, (xCell + 0.5) * (100 / gridSize) + jitter()));
      const startY = Math.min(99, Math.max(0, (yCell + 0.5) * (100 / gridSize) + jitter()));
      const startZ = `${Math.round(Math.random() * 100)}px`;
      const endX = `${Math.round(Math.random() * 100)}vw`;
      const endY = `${Math.round(Math.random() * 100)}vh`;
      const endZ = `${Math.round(Math.random() * 100)}px`;
      const size = `${6 + Math.round(Math.random() * 4)}px`;
      const color = `hsl(${160 + Math.random() * 40}, 70%, 85%)`;
      const opacity = +(0.1 + Math.random() * 0.9).toFixed(2);
      const delay = `-${(Math.random() * 6).toFixed(1)}s`;
      particles.push({
        size: size,
        color: color,
        opacity: opacity,
        delay: delay,
        startX: `${startX}vw`,
        startY: `${startY}vh`,
        startZ: startZ,
        endX: endX,
        endY: endY,
        endZ: endZ,
      });
    }
    return particles;
  }
}
